import { gql } from "@apollo/client";

export const ADD_WEBHOOK = gql`
	mutation addWebhook(
		$targetUrl: String!, 
		$type: String!, 
		$isCreated: Boolean!, 
		$isSent: Boolean!, 
		$isDelivered: Boolean!, 
		$isRead: Boolean!, 
		$isFailed: Boolean!
	) {
		insert_msgbox_ZapierWebhook(
			objects: { 
				Target_Url: $targetUrl, 
				Type: $type, 
				IsZapier: false,
				IsCreated: $isCreated,
				IsSent: $isSent,
				IsDelivered: $isDelivered,
				IsRead: $isRead,
				IsFailed: $isFailed
			}
		) {
			affected_rows
		}
	}
`;

export const UPDATE_WEBHOOK = gql`
	mutation updateWebhook(
		$id: Int!,
		$targetUrl: String,
		$type: String,
		$isCreated: Boolean!, 
		$isSent: Boolean!, 
		$isDelivered: Boolean!, 
		$isRead: Boolean!, 
		$isFailed: Boolean!
	) {
		update_msgbox_ZapierWebhook(
			where: { ZapierWebHookId: { _eq: $id } }
			_set: { 
				Target_Url: $targetUrl,
				Type: $type,
				IsCreated: $isCreated,
				IsSent: $isSent,
				IsDelivered: $isDelivered,
				IsRead: $isRead,
				IsFailed: $isFailed
			}
		) {
			affected_rows
		}
	}
`;

export const DELETE_WEBHOOK = gql`
	mutation deleteWebhook($id: Int!) {
		delete_msgbox_ZapierWebhook(where: { ZapierWebHookId: { _eq: $id } }) {
			affected_rows
		}
	}
`;

export const SET_WEBHOOK_DISABLED= gql`
	mutation enableWebhook($id: Int) {
		update_msgbox_ZapierWebhook(
			where: { ZapierWebHookId: { _eq: $id } }
			_set: { IsEnabled: false }
		) {
			affected_rows
		}
	}
`;

export const SET_WEBHOOK_ENABLED = gql`
	mutation enableWebhook($id: Int) {
		update_msgbox_ZapierWebhook(
			where: { ZapierWebHookId: { _eq: $id } }
			_set: { IsEnabled: true , FailureCount: 0}
		) {
			affected_rows
		}
	}
`;

export const GET_WEBHOOKS = gql`
	query getWebhooks {
		msgbox_ZapierWebhook(where: {IsZapier: {_eq: false}}, order_by: {ZapierWebHookId: desc}) {
		Target_Url
		Type
		IsZapier
		IsEnabled
		FailureCount
		ZapierWebHookId
		IsCreated
		IsSent
		IsDelivered
		IsRead
		IsFailed
		}
	}
`;

export const GET_ZAPIER_WEBHOOKS = gql`
	query getZapierWebhooks {
		msgbox_ZapierWebhook(where: { IsZapier: { _eq: true } }) {
			Target_Url
			Type
			IsZapier
			IsEnabled
			FailureCount
			ZapierWebHookId
		}
	}
`;

export const GET_WEBHOOK_LOGS = gql`
	query getWebhooksLogs(
		$limit: Int
		$offset: Int
		$order_by: msgbox_ZapierWebhookLog_order_by!
	) {
		msgbox_ZapierWebhookLog(
			limit: $limit
			offset: $offset
			order_by: [$order_by]
		) {
			CreatedAt
			Type
			ResultCode
			Result
			ZapierWebhook {
				Target_Url
				Type
				IsZapier
				IsEnabled
				FailureCount
			}
		}
		# msgbox_ZapierWebhookLog_aggregate {
		# 	aggregate {
		# 		count
		# 	}
		# }
	}
`;

export const GET_API_KEYS = gql`
	query getAPIKeys {
		msgbox_APIKey {
			APIKeyId
			Key
			Enabled
		}
	}
`

export const SET_API_KEY_ENABLED = gql`
	mutation enableAPIKey($id: Int) {
		update_msgbox_APIKey(
			where: { APIKeyId: { _eq: $id } }
			_set: { Enabled: true }
		) {
			affected_rows
		}
	}
`;

export const SET_API_KEY_DISABLED = gql`
	mutation disableAPIKey($id: Int) {
		update_msgbox_APIKey(
			where: { APIKeyId: { _eq: $id } }
			_set: { Enabled: false }
		) {
			affected_rows
		}
	}
`;

export const DELETE_API_KEY = gql`
	mutation deleteAPIKey($id: Int!) {
		delete_msgbox_APIKey(where: { APIKeyId: { _eq: $id } }) {
			affected_rows
		}
	}
`;

export const ADD_API_KEY = gql`
	mutation addAPIKey(
		$key: String!,
		#$enabled: Boolean!,
		#$organisationId: Int!,
		#$userId: Int!
	) {
		insert_msgbox_APIKey(
			objects: { 
				Key: $key,
				#Enabled: $enabled,
				#OrganisationId: $organisationId,
				#UserId: $userId
			}
		) {
			affected_rows
		}
	}
`;